// routes.js - Lazy loaded for better performance
import lazyWithRetry from '../utils/lazyWithRetry';

// Lazy load components to reduce initial bundle size. Using lazyWithRetry so
// that a chunk-load failure (old tab open across a deploy → hashed chunk URL
// no longer exists on Hosting) triggers a one-time reload to pick up the new
// bundle instead of dropping the user on the ErrorBoundary screen.
const SongListHome = lazyWithRetry(() => import('../components/SongListHome'));
const Login = lazyWithRetry(() => import('../screens/Login'));
const SongScreen = lazyWithRetry(() => import('../screens/SongScreen'));
const UserScreen = lazyWithRetry(() => import('../screens/UserScreen'));
const NotificationsScreen = lazyWithRetry(
  () => import('../screens/NotificationsScreen')
);
const SearchScreen = lazyWithRetry(() => import('../screens/SearchScreen'));
const About = lazyWithRetry(() => import('../screens/About'));
const ServiceWorkerDemo = lazyWithRetry(
  () => import('../components/ServiceWorkerDemo')
);
const TosScreen = lazyWithRetry(() => import('../screens/TosScreen'));
const PrivacyScreen = lazyWithRetry(() => import('../screens/PrivacyScreen'));
const NotFoundScreen = lazyWithRetry(() => import('../screens/NotFoundScreen'));
const SettingsScreen = lazyWithRetry(() => import('../screens/SettingsScreen'));

const routes = [
  {
    path: '/',
    component: (props) => <SongListHome {...props} />,
    name: 'Home Page',
    protected: true,
    container: 'navWindow',
  },
  {
    path: '/login',
    component: Login,
    name: 'Login Screen',
    protected: false,
    container: 'navWindow',
  },
  {
    path: '/user/:id',
    component: (props) => <UserScreen {...props} />,
    name: 'User Page',
    protected: false,
    container: 'navWindow',
  },
  {
    path: '/song/:id',
    component: SongScreen,
    name: 'Song Page',
    protected: false,
    container: 'mainBody',
  },
  {
    path: '/notifs/:userId',
    component: NotificationsScreen,
    name: 'Notifications',
    protected: true,
    container: 'mainBody',
  },
  {
    path: '/search',
    component: SearchScreen,
    name: 'Search',
    protected: false,
    container: 'navWindow',
  },
  {
    path: '/settings',
    component: SettingsScreen,
    name: 'Settings',
    protected: true,
    container: 'navWindow',
  },
  {
    path: '/about',
    component: About,
    name: 'About',
    protected: false,
    container: 'mainBody',
  },
  {
    path: '/performance-demo',
    component: ServiceWorkerDemo,
    name: 'Performance Demo',
    protected: false,
    container: 'mainBody',
  },
  {
    path: '/tos',
    component: TosScreen,
    name: 'Terms of Service',
    protected: false,
    container: 'mainBody',
  },
  {
    path: '/privacy',
    component: PrivacyScreen,
    name: 'Privacy Policy',
    protected: false,
    container: 'mainBody',
  },
  {
    path: '*',
    component: NotFoundScreen,
    name: 'Not Found',
    protected: false,
    container: 'mainBody',
  },
];

export default routes;
